import { useMutation } from '@apollo/client';
import { UPDATE_USER } from '../../graphql/mutations/user';

export const useUpdateUser = (options?: {
  onCompleted: (data: any) => void,
  onError: () => void,
  refetchQueries?: [string],
  awaitRefetchQueries?: boolean,
}) => useMutation(UPDATE_USER, options);
